import {defineStore} from 'pinia'
import Client from "../utils/client";


export const useAuthStore = defineStore('authStore', {
    state: () => ({
        jwt: sessionStorage.getItem("jwt"),
        client: new Client(sessionStorage.getItem("jwt"))
    }),
    getters: {
        isLoggedIn: (state) => !!state.jwt,
    },
    actions: {
        // any amount of arguments, return a promise or not
        setJwt(jwt) {
            sessionStorage.setItem("jwt", jwt)
            this.jwt = jwt
            this.client = new Client(jwt)
        }
    }
})